export const roleCheck = (allowedRoles: string[], roleBo?: string) => {
  if (!roleBo) return false;
  return allowedRoles.includes(roleBo);
};
